import { useState } from "react";

// Location capture hook or utility
export const useLocationCapture = () => {
  const [isCapturing, setIsCapturing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const captureLocation = (): Promise<{latitude: number; longitude: number}> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error('Geolocation not supported'));
        return;
      }

      setIsCapturing(true);
      setError(null);

      navigator.geolocation.getCurrentPosition(
        (position) => {
          setIsCapturing(false);
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (err) => {
          setIsCapturing(false);
          let errorMsg = 'Failed to get location';
          switch (err.code) {
            case err.PERMISSION_DENIED:
              errorMsg = 'Location permission denied';
              break;
            case err.POSITION_UNAVAILABLE:
              errorMsg = 'Location unavailable';
              break;
            case err.TIMEOUT:
              errorMsg = 'Location request timed out';
              break;
          }
          setError(errorMsg);
          reject(new Error(errorMsg));
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  };

  return { captureLocation, isCapturing, error };
};

export default useLocationCapture;
